import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';
import apiClient from '../apiClient';
import {
  ApiResponseType,
  GetPropertiesParams,
  PaginationResponseType,
  responseWrapper,
} from '../helpers';
import { API_QUERIES } from '../keys';
import { CheckRegisterListingItem } from './types';

export function useGetCheckRegisterListing(
  options?: UseQueryOptions<
    ApiResponseType<PaginationResponseType<CheckRegisterListingItem>>,
    Error,
    PaginationResponseType<CheckRegisterListingItem>
  >
) {
  const [params, setParams] = useState<GetPropertiesParams>({});

  const {
    data: allCheckRegisterListingResponse,
    error,
    isFetching,
    refetch: onGetCheckRegisterListing,
  } = useQuery<
    ApiResponseType<PaginationResponseType<CheckRegisterListingItem>>,
    Error,
    PaginationResponseType<CheckRegisterListingItem>
  >([API_QUERIES.GET_CHECK_REGISTER_LISTING, params], {
    queryFn: (query) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...params] = query.queryKey;
      return responseWrapper<ApiResponseType<PaginationResponseType<CheckRegisterListingItem>>>(
        apiClient.getCheckRegisterListing,
        params
      );
    },
    notifyOnChangeProps: ['data', 'isFetching'],
    keepPreviousData: true,
    enabled: !isEmpty(params),
    ...options,
  });

  const queryClient = useQueryClient();

  const handleInvalidateCheckRegisterListing = () =>
    queryClient.invalidateQueries(API_QUERIES.GET_CHECK_REGISTER_LISTING);

  const {
    data: checkRegisterListing,
    hasNext,
    payloadSize,
    totalRecords,
  } = allCheckRegisterListingResponse || {};

  return {
    checkRegisterListing,
    hasNext,
    payloadSize,
    totalRecords,
    error,
    isFetching,
    setParams,
    onGetCheckRegisterListing,
    handleInvalidateCheckRegisterListing,
  };
}
